import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=7d508301&scoped=true"
import script from "./rank.vue?vue&type=script&lang=js"
export * from "./rank.vue?vue&type=script&lang=js"
import style0 from "./rank.vue?vue&type=style&index=0&id=7d508301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d508301",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RalfNavBar: require('/Users/apple/Sites/yikaowep/components/ralfNavBar.vue').default})
